import React, { PureComponent } from 'react';

export default class DocContextMenu extends PureComponent {
    componentDidUpdate() {
        this.updateMenu();
    }

    updateMenu() {
        const menu = this.menu;
        if (!menu) return;

        const { value } = this.props;
        const { fragment, selection } = value;

        if (selection.isBlurred || selection.isCollapsed || fragment.text === '') {
            menu.removeAttribute('style');

            return;
        }

        const native = window.getSelection();
        const range = native.getRangeAt(0);
        const rect = range.getBoundingClientRect();
        menu.style.opacity = 1;

        if (rect.top > window.innerHeight / 2) {
            menu.style.top = `${rect.top + window.pageYOffset - menu.offsetHeight - 8}px`;
        } else {
            menu.style.top = `${rect.bottom + window.pageYOffset + 8}px`;
        }

        menu.style.left = `${rect.left +
            window.pageXOffset -
            menu.offsetWidth / 2 +
            rect.width / 2}px`;
    }

    render() {
        return (
            <div className="doc-context-menu" ref={el => this.menu = el}>
                {this.props.children}
            </div>
        )
    }
}
